<ng-container *transloco="let t; read: 'sesion-activa'">
  <h2 mat-dialog-title class="sesion-activa__title">
    <mat-icon class="sesion-activa__title-icon">schedule</mat-icon>
    <span>{{ t('titulo') }}</span>
  </h2>

  <mat-dialog-content style="overflow: visible; padding-bottom: 0;">
    <p class="sesion-activa__mensaje">{{ t('mensaje') }}</p>

    <div class="sesion-activa__contador" aria-live="polite">
      {{ data.segundosRestantes() }}
    </div>
    <p class="sesion-activa__restantes">{{ t('restantes') }}</p>

    <mat-progress-bar mode="determinate" [value]="progreso()"></mat-progress-bar>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="padding_25 gap_10">
    <button mat-raised-button color="primary" type="button" (click)="continuar()">
      {{ t('continuar') }}
    </button>
  </mat-dialog-actions>
</ng-container>